import React from 'react';
import { Image } from '../BlockLibrary/Common/Image';

const SliderItem = ({ testimonial }) => {
     const { image, quote, customerName, moreInfo, shortTitle } = testimonial;

     return (
          <div className="item">
               <Image image={image} />
               <div className="testimonial">
                    {shortTitle && <p>{shortTitle}</p>}
                    <div className="wrap">
                         <div className="quote"><p>- "{quote}"</p></div>
                         <div className="speaker">
                              <p className="name">{customerName},</p>
                              {moreInfo && <p className="more-info">{moreInfo}</p>}
                         </div>
                    </div>
               </div>
          </div>
     )
}

const FullWidthContent = ({ testimonial }) => {
     const { image, quote, customerName, moreInfo } = testimonial;
     let style = image?.file?.url ? { backgroundImage: `url(${image.file.url})` } : {};
     if (testimonial.sys) {
          style = image?.fields?.file?.url ? { backgroundImage: `url(${image.fields.file.url})` } : {};
     }

     return (
          <div className="block-testimonial full-width">
               <div className="testimonial-image" style={style}></div>
               <div className="testimonial">
                    <span className="quote-begin">“</span>
                    <div className="quote"><p>{quote}</p></div>
                    <div className="speaker">
                         <p className="name">- {customerName}</p>
                         {moreInfo && <p className="more-info">{moreInfo}</p>}
                    </div>
                    <span className="quote-end">“</span>
               </div>
          </div>
     )
}

const TitleTopQuoteBottom = ({ testimonial }) => {
     const { image, quote, customerName, moreInfo, shortTitle } = testimonial;
     let style = image?.file?.url ? { backgroundImage: `url(${image.file.url})` } : {};
     if (image && image.fields) {
          style = image.fields.file?.url ? { backgroundImage: `url(${image.fields.file.url})` } : image?.file?.url ? { backgroundImage: `url(${image.file.url})` } : {};
     }

     return (
          <div className="block-testimonial title-top-quote-bottom" style={style}>
               <div className="testimonial">
                    {shortTitle && <p>{shortTitle}</p>}
                    <div className="wrap">
                         <div className="quote"><p>{quote}</p></div>
                         <div className="speaker">
                              <p className="name">- {customerName}</p>
                              {moreInfo && <p className="more-info">{moreInfo}</p>}
                         </div>
                    </div>
               </div>
          </div>
     )
}

const ContentfulBlockTestimonial = (testimonial) => {
     let content = '';
     if (testimonial.layoutTemplate) {
          switch (testimonial.layoutTemplate) {
               case 'Full Width':
                    content = (<FullWidthContent testimonial={testimonial} />);
                    break;
               case 'Title Top, Quote Bottom':
                    content = (<TitleTopQuoteBottom testimonial={testimonial} />);
                    break;
               case 'Slider Item':
               default:
                    content = (<SliderItem testimonial={testimonial} />);
                    break;
          }
     } else {
          content = (<SliderItem testimonial={testimonial} />);
     }

     return (content)
}

export { ContentfulBlockTestimonial }
